import React from 'react';
import { BarChart } from '@mui/x-charts/BarChart';
import { useMediaQuery } from '@mui/material';

function Markrt({ marketBarChartData }) {
    const showData = marketBarChartData.data || [];
    const isNarrowScreen = useMediaQuery('(max-width:920px)');

    const calData = () => {

    }

    console.log("showData",showData);
    

    return (
        <BarChart
            height={250}
            width={isNarrowScreen ? 1200 : 1700}
            xAxis={[{
                id: 'barCategories',
                data: showData.map(item => item.userName),
                scaleType: 'band',
                tickPlacement: 'middle',
            }]}
            series={[
                {
                    label: 'Total System Size (kW)',
                    data: showData.map(item => item.totalSystemSizeKw),
                },
                {
                    label: 'No. of Customers',
                    data: showData.map(item => item.allFileNumbers.length)
                }
            ]}
        />
    )
} export default Markrt